import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';
import project1 from '../../../images/rsz_schoz.png';
import project2 from '../../../images/food-valley.PNG';
import project3 from '../../../images/town.PNG';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faExternalLinkSquareAlt } from '@fortawesome/free-solid-svg-icons'
import './Project.css';
import { Link } from 'react-router-dom';
import Aos from 'aos';
import "aos/dist/aos.css"

const Project = () => {

    useEffect(() => {
        Aos.init({ duration: 2000 });
    }, []);

    return (
        <main className="prot">
            <div className="container">
                <div className="mb-5">
                    <h2 className="page-title text-left pt-5 mb-5">My Works</h2>
                    <div className="card-deck mainCard zoom-effect-container">
                        <div data-aos="fade-right" className="card cardColor zoom-effect mx-md-3 col-md-4" style={{ boxShadow: "10px 10px 5px 5px rgba(0,0,0,0.3)" }}>
                            <article>
                                <img className="card-img-top" src={project1} alt="" />


                                <div className="card-body">
                                    <div className="card-title">
                                        <h5 className="projectTitle">Shohoz Sheba</h5>
                                    </div>
                                    <p className="small projectP card-text">Responsive MERN Stack project with firebase authentication, admin authentication, persistent login and dashboard functionality for customer and admin User have ability to order available.</p>
                                    <div className="d-flex justify-content-between">
                                        <div className="technologyP">
                                            <span>React.js</span>
                                            <span>Express.js</span>
                                            <span>Node js</span>
                                            <span>MongoDB</span>
                                            <span>Material UI</span>
                                            <span>Firebase</span>
                                            <span>Heroku</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-fotter">

                                    <div style={{ fontSize: "2rem", color: '#F5DF4E' }} className="d-flex justify-content-center">
                                        <a href="https://github.com/Tanjin9185/shohoz-sheva-client" title="Github Repository" target="_blank">
                                            <div className="text px-5"> <FontAwesomeIcon icon={faGithub} /></div>

                                        </a>
                                        <a href="https://shohoz-sebha.web.app/" title="Visit Live Site." target="_blank">
                                            <div className="text px-5"> <FontAwesomeIcon icon={faExternalLinkSquareAlt} /></div>

                                        </a>
                                    </div>
                                </div>
                            </article>
                        </div>

                        <div data-aos="zoom-out" className="card cardColor zoom-effect mx-md-4 col-md-4" style={{ boxShadow: "10px 10px 5px 5px rgba(0,0,0,0.3)" }}>
                            <article>
                                <img className="card-img-top" src={project2} alt="" />
                                <div className="card-body">
                                    <div className="card-title">
                                        <h5 className="projectTitle">Food Valley</h5>
                                    </div>
                                    <p className="small projectP card-text">A MERN stack application. Responsive for tablet, mobile and PC. User authorization Admin and User. Authentication (Google) added.</p>
                                    <div className="d-flex justify-content-between">
                                        <div className="technologyP">
                                            <span>React.js</span>
                                            <span>Express.js</span>
                                            <span>Node js</span>
                                            <span>MongoDB</span>
                                            <span>React Bootstrap</span>
                                            <span>Firebase</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-fotter">

                                    <div style={{ fontSize: "2rem", color: '#F5DF4E' }} className="d-flex justify-content-center">
                                        <a href="https://github.com/Tanjin9185/food-valley-client" title="Github Repository" target="_blank">
                                            <div className="text px-5"> <FontAwesomeIcon icon={faGithub} /></div>

                                        </a>
                                        <a href="https://food-valley-2dcb2.web.app/" title="Visit Live Site." target="_blank">
                                            <div className="text px-5"> <FontAwesomeIcon icon={faExternalLinkSquareAlt} /></div>

                                        </a>
                                    </div>
                                </div>
                            </article>
                        </div>

                        <div data-aos="fade-left" className="card cardColor mx-md-4 zoom-effect col-md-4" style={{ boxShadow: "10px 10px 5px 5px rgba(0,0,0,0.3)" }}>
                            <article>
                                <img className="card-img-top" src={project3} alt="" />
                                <div className="card-body">
                                    <div className="card-title">
                                        <h5 className="projectTitle">Town Ride</h5>
                                    </div>
                                    <p className="small projectP card-text">A web app where people can hire vehicles. You can see vehicle's total seats and price Login with Google, Facebook, Email & Password You can search by the location where you want to go</p>
                                    <div className="d-flex justify-content-between">
                                        <div className="technologyP">
                                            <span>JavaScripts</span>
                                            <span>ES6</span>
                                            <span>React.js</span>
                                            <span>Node.js</span>
                                            <span>Google Map API</span>
                                            <span>React Hook Form</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-fotter">

                                    <div style={{ fontSize: "2rem", color: '#F5DF4E' }} className="d-flex justify-content-center">
                                        <a href="https://github.com/Tanjin9185/town-ride" title="Github Repository" target="_blank">
                                            <div className="text px-5"> <FontAwesomeIcon icon={faGithub} /></div>

                                        </a>
                                        <a href="https://town-ride.web.app/" title="Visit Live Site." target="_blank">
                                            <div className="text px-5"> <FontAwesomeIcon icon={faExternalLinkSquareAlt} /></div>

                                        </a>
                                    </div>
                                </div>
                            </article>
                        </div>
                    </div>
                    <div className="my-5 pb-5 d-flex align-items-center justify-content-center">
                        <Link to="/mainProject" className="btn text-center morePro">More Project</Link>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default Project;